import { useEffect, useRef } from 'react';

import Button from '@/componentsv2/Button';

interface SocialSignupChoiceProps {
  /** The provider account's email, which no OnFrontiers account uses. */
  email: string;
  customerPath: string;
  expertPath: string;
  /** Router state that hands the sign-up to either form. */
  signupState: { socialSignup: string };
  onUseDifferentAccount: () => void;
}

// ENG-6311: Google or Microsoft found no account. The login card asks for the
// role itself, so the sign-up goes straight to its form.
export function SocialSignupChoice({
  email,
  customerPath,
  expertPath,
  signupState,
  onUseDifferentAccount,
}: SocialSignupChoiceProps): JSX.Element {
  // It replaces the card the person just used: focus goes to its question.
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => heading.current?.focus(), []);

  return (
    // Centred in the login column, like SocialConnectStep.
    <div className="mx-auto flex w-full max-w-[360px] flex-col gap-16 text-center">
      <p role="status" className="m-[0] break-words text-on-surface">
        {`No account for ${email} yet.`}
      </p>
      <h2 ref={heading} tabIndex={-1} className="m-[0] outline-none">
        How do you want to use OnFrontiers?
      </h2>
      <Button className="min-h-48 text-center" to={customerPath} state={signupState}>
        Find an expert
      </Button>
      <Button
        className="min-h-48 text-center"
        variant="secondary"
        to={expertPath}
        state={signupState}
      >
        Become an expert
      </Button>
      <p className="m-[0] text-on-surface-muted">
        Not you?{' '}
        <Button className="min-h-48" variant="tertiary" onClick={onUseDifferentAccount}>
          Use a different account
        </Button>
      </p>
    </div>
  );
}
